export default __webpack_public_path__ + "static/media/empty.a00d3182.png";